export default "__VITE_ASSET__073b64da__"